import { config } from './config';

interface StructuredLogEntry {
  level: 'info' | 'debug' | 'error' | 'warn';
  message: string;
  [key: string]: unknown;
}

export const convergeLogger = {
  ...console,
  log: (...args: unknown[]) => {
    if (config.debug) {
      console.log(...args);
    }
  },
  debug: (...args: unknown[]) => {
    if (config.debug) {
      console.debug(...args);
    }
  },
  structured: (entry: StructuredLogEntry) => {
    const { level, ...data } = entry;
    const logFn = console[level] || console.log;
    logFn(JSON.stringify(data));
  },
};
